// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"806d265b63aa1ecb8d04","303":"177ebdb533293d3b82f7","495":"6200799e4cfa85289459"}[chunkId] + ".js";
};